import * as mt from "./mutation-types";
import { Farm, FarmListRow, FarmListFilter } from "@/api/farms/types";
import { RootState } from "../types";
import { FarmsState } from "./types";
import { ActionContext } from "vuex";

export default {
  [mt.CLEAR_FARMS]({ commit }: ActionContext<FarmsState, RootState>) {
    commit(mt.CLEAR_FARMS);
  },
  [mt.FARMS_REQUEST]({ commit }: ActionContext<FarmsState, RootState>) {
    commit(mt.FARMS_REQUEST);
  },

  [mt.FARMS_REQUEST_SUCCESS](
    { commit }: ActionContext<FarmsState, RootState>,
    farms: Farm[]
  ) {
    commit(mt.FARMS_REQUEST_SUCCESS, { farms });
  },

  [mt.FARMS_REQUEST_ERROR]({ commit }: ActionContext<FarmsState, RootState>) {
    commit(mt.FARMS_REQUEST_ERROR);
  },
  [mt.CREATE_FARMS_REQUEST]({ commit }: ActionContext<FarmsState, RootState>) {
    commit(mt.CREATE_FARMS_REQUEST);
  },
  [mt.CREATE_FARMS_SUCCESS]({ commit }: ActionContext<FarmsState, RootState>) {
    commit(mt.CREATE_FARMS_SUCCESS);
  },
  [mt.CREATE_FARMS_FAILURE]({ commit }: ActionContext<FarmsState, RootState>) {
    commit(mt.CREATE_FARMS_FAILURE);
  },

  [mt.FARM_DELETE]({ commit }: ActionContext<FarmsState, RootState>) {
    commit(mt.FARM_DELETE);
  },
  [mt.FARM_DELETE_SUCCESS]({ commit }: ActionContext<FarmsState, RootState>) {
    commit(mt.FARM_DELETE_SUCCESS);
  },
  [mt.FARM_DELETE_ERROR]({ commit }: ActionContext<FarmsState, RootState>) {
    commit(mt.FARM_DELETE_ERROR);
  },

  [mt.FARM_LIST_CLEAR]({commit}: ActionContext<FarmsState, RootState>) {
    commit(mt.FARM_LIST_CLEAR)
  },
  [mt.FARM_LIST_REQUEST]({commit}: ActionContext<FarmsState, RootState>) {
    commit(mt.FARM_LIST_REQUEST);
  },
  [mt.FARM_LIST_SUCCESS]({commit}: ActionContext<FarmsState, RootState>, { farmList }: { farmList: FarmListRow }) {
    commit(mt.FARM_LIST_SUCCESS, { farmList });
  },

  [mt.FARM_LIST_FILTER_PERSIST]({commit}: ActionContext<FarmsState, RootState>, { filter }: { filter: FarmListFilter }) {
    commit(mt.FARM_LIST_FILTER_PERSIST, { filter });
  },
  [mt.FARM_LIST_CLEAR]({commit}: ActionContext<FarmsState, RootState>) {
    commit(mt.FARM_LIST_CLEAR);
  },

  [mt.FARM_LIST_ERROR]({commit}: ActionContext<FarmsState, RootState>) {
    commit(mt.FARM_LIST_ERROR);
  },
};
